module.exports = __webpack_public_path__ + "img/shg54_samurai01skin_shop.cad92616.png";